import React from 'react';
import { useIntl } from 'react-intl';

import { SMSProviders } from '../../../api';
import { SMS_LINKS } from '../../../constants';
import { FieldInput } from '../../ui';
import {
  DescriptionLink,
  FieldWrapper,
  ProviderSubtitle,
  ProviderTitle,
  SmsProviderFieldsCard,
  SmsProviderHeader
} from '../style';
import { SMSProviderStatus } from './SMSProviderStatus';
import { ProviderFieldProps } from './types';
import { maxFieldLength, maxPhoneNumberLength } from './validator';

export const SinchFields = ({ errors, providerData }: ProviderFieldProps): JSX.Element => {
  const intl = useIntl();
  const { SINCH_SERVICE_PLAN, SINCH_API } = SMS_LINKS;

  const getError = (field: string): string => {
    if (errors[SMSProviders.sinch][field]) {
      return intl.formatMessage(
        { id: errors[SMSProviders.sinch][field] as string },
        {
          number: field === 'phone_number' ? maxPhoneNumberLength : maxFieldLength
        }
      );
    }

    return '';
  };

  return (
    <SmsProviderFieldsCard data-test-id="sms-provider-fields-card-sinch">
      <SmsProviderHeader>
        <ProviderTitle>
          {intl.formatMessage({ id: 'custom-providers.settings.sms.provider.sinch.label' })}
        </ProviderTitle>
        <SMSProviderStatus
          providerData={providerData}
          dataTestId="sms-provider-sinch-status-button"
        />
      </SmsProviderHeader>
      <ProviderSubtitle>
        {intl.formatMessage(
          { id: 'custom-providers.settings.sms.provider.sinch.description' },
          {
            a: (chunk: string) => (
              <DescriptionLink href={SINCH_API} target="_blank">
                {chunk}
              </DescriptionLink>
            )
          }
        )}
      </ProviderSubtitle>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.sinch.plan-id.label'
          })}
          subLabel={intl.formatMessage(
            {
              id: 'custom-providers.settings.sms.provider.sinch.plan-id.sublabel'
            },
            {
              a: (chunk: string) => (
                <DescriptionLink href={SINCH_SERVICE_PLAN} target="_blank">
                  {chunk}
                </DescriptionLink>
              )
            }
          )}
          errorMessage={getError('app_id')}
          name={`fields.${SMSProviders.sinch}.app_id`}
        />
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.sinch.auth-token.label'
          })}
          errorMessage={getError('app_secret')}
          name={`fields.${SMSProviders.sinch}.app_secret`}
        />
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.sinch.phone.label'
          })}
          errorMessage={getError('phone_number')}
          name={`fields.${SMSProviders.sinch}.phone_number`}
        />
      </FieldWrapper>
    </SmsProviderFieldsCard>
  );
};
